<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId; else previewBlock">
    <div edsGrid>
      <div
        class="container"
        [ngClass]="{
          'container--wide': containerWideClass === 'yes',
          container: containerWideClass === 'no',
          'container--none': containerWideClass === 'none'
        }"
      >
        <div edsRow *ngIf="fundManagementInfo?.investmentTeam.length > 0">
          <div edsCol>
            <section
              edsBackground
              theme="light"
              edsPadding
              edsPaddingBottom="md"
              edsPaddingTop="xl"
              edsPaddingLeft="xl"
              edsPaddingRight="xl"
            >
              <ng-container *ngIf="fundManagementInfo">
                <eds-title
                  [isLight]="false"
                  theme="dark"
                  size="h3"
                  edsSpacing="lg"
                  >{{
                    "products.fund-management-header"
                      | translate: brConfig.fundId
                  }}</eds-title
                >
                <div
                  edsCol
                  edsSubGrid="layout-2"
                  edsSubGridTablet="layout-1"
                  class="fund-manager__container"
                >
                  <ng-container
                    *ngFor="
                      let investmentManager of fundManagementInfo.investmentTeam
                    "
                  >
                    <eds-avatar
                      class="fund-manager__block"
                      *ngIf="
                        showLinkToBios &&
                        investmentManager.profile?.content?.content
                      "
                      [title]="getManagerTitle(investmentManager)"
                      [text1]="investmentManager.managerCity"
                      text2="{{
                        investmentManager.startDateFundManagementStd
                          ? ('products.managed-fund-since'
                            | translate: brConfig.fundId)
                          : ''
                      }} {{
                        investmentManager.startDateFundManagementStd
                          | date: 'yyyy'
                      }}"
                      [yrsIndustry]="
                        hasYearsOfExperience
                          ? yearsOfExperienceLabel +
                            ': ' +
                            investmentManager.yearsInIndustry
                          : ''
                      "
                      [imgSrc]="
                        investmentManager.profile?.profileImage?.widenAsset?.url
                      "
                      fallbackImgSrc="/assets/images/ben_head.png"
                      edsSpacing="xl"
                      href="#"
                      (click)="clickAvatar($event)"
                      (onTitleClick)="openFullProfile(investmentManager)"
                    >
                    </eds-avatar>
                    <!-- NGC-8631: PM CFS title missing for the following managers -->
                    <eds-avatar
                      *ngIf="
                        !(
                          showLinkToBios &&
                          investmentManager.profile?.content?.content
                        )
                      "
                      [title]="getManagerTitle(investmentManager)"
                      [text1]="investmentManager.managerCity"
                      text2="{{
                        investmentManager.startDateFundManagementStd
                          ? ('products.managed-fund-since'
                            | translate: brConfig.fundId)
                          : ''
                      }} {{
                        investmentManager.startDateFundManagementStd
                          | date: 'yyyy'
                      }}"
                      [yrsIndustry]="
                        hasYearsOfExperience
                          ? yearsOfExperienceLabel +
                            ': ' +
                            investmentManager.yearsInIndustry
                          : ''
                      "
                      [imgSrc]="
                        investmentManager.profile?.profileImage?.widenAsset?.url
                      "
                      fallbackImgSrc="/assets/images/ben_head.png"
                      edsSpacing="xl"
                    >
                    </eds-avatar>
                  </ng-container>
                </div>
              </ng-container>
            </section>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <h5>Fund Manager Component</h5>
</ng-template>

<eds-simple-modal
  *ngIf="brConfig"
  [modalId]="ModalId['Profile_Modal']"
  size="large"
  aria-label="Close"
>
  <div modal-body>
    <ft-manager-profile
      [investmentTeam]="investmentManagerInfo"
      [managerTitleSuffix]="investmentManagerInfo ? managerTitleSuffix : ''"
      summaryLabel="{{
        'products.manager-profile-summary' | translate: brConfig.fundId
      }}"
      designationsLabel="{{
        'products.manager-profile-designations' | translate: brConfig.fundId
      }}"
      timeInIndustryLabel="{{
        'products.manager-profile-time-in-industry' | translate: brConfig.fundId
      }}"
      teamOrSimLabel="{{
        'products.manager-profile-team-or-sim' | translate: brConfig.fundId
      }}"
      timeInFundLabel="{{
        'products.manager-profile-time-in-fund' | translate: brConfig.fundId
      }}"
      locationLabel="{{
        'products.manager-profile-location' | translate: brConfig.fundId
      }}"
    ></ft-manager-profile>
  </div>
</eds-simple-modal>
